// Base URL for the self_enroll backend.
// When REACT_APP_SELF_ENROLL_API_URL is unset, routes are same-origin (e.g. /api/v2/...),
// so whichever host serves this SPA (selfenroll.proptech.ai vs eu-selfenroll.proptech.ai)
// also receives API calls — no per-region build needed.
// Set REACT_APP_SELF_ENROLL_API_URL for local dev when the API runs on another origin/port.
const rawBase = process.env.REACT_APP_SELF_ENROLL_API_URL;
const API_BASE = rawBase ? rawBase.replace(/\/$/, "") : "";

export const Config = {
    routes: {
        register: `${API_BASE}/api/v2/enroll/`,
        selfRegister: `${API_BASE}/api/v2/self-config-enroll/`,
        sendSMSCods: `${API_BASE}/api/v2/send-sms-code/`,
        validateSMSCode: `${API_BASE}/api/v2/validate-sms-code/`,
        siteDetails: `${API_BASE}/api/v2/site-details/`,
    },
};
